import { LucideIcon } from 'lucide-react';

interface ServiceCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
}

export function ServiceCard({ title, description, icon: Icon }: ServiceCardProps) {
  return (
    <div className="group relative overflow-hidden rounded-lg bg-[#1E293B] p-8 shadow-lg transition-all 
                 hover:shadow-2xl hover:shadow-red-500/30 border border-gray-700 
                 hover:border-red-500 hover:bg-[#2A1B1B] hover:scale-105 duration-500 ease-in-out 
                 h-full flex flex-col">
      
      {/* Icono en la parte superior */}
      <div className="mb-4 inline-block rounded-lg bg-lime-500/20 p-4">
        <Icon className="h-8 w-8 text-lime-400" />
      </div>

      {/* Contenido con flex-grow para igualar alturas */}
      <div className="flex-grow">
        <h3 className="mb-2 text-xl font-semibold tracking-tight text-white">{title}</h3>
        <p className="text-gray-300">{description}</p>
      </div>
    </div>
  );
}
